export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "016e3d9.worker.js");
}
